import { render, staticRenderFns } from "./AttestationFiscale.vue?vue&type=template&id=a46982c2&scoped=true&"
import script from "./AttestationFiscale.vue?vue&type=script&lang=js&"
export * from "./AttestationFiscale.vue?vue&type=script&lang=js&"
import style0 from "./AttestationFiscale.vue?vue&type=style&index=0&id=a46982c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46982c2",
  null
  
)

export default component.exports